/**
 * @summary     app.requirer.js
 * @description Required fields validator
 * @version     1.6
 	> 1.0 Initial version
		- 08/22/2016 SG
	> 1.1 Bug fix - the "pass" statement was doing toString() on undefined.  Added conversionTypes to convert values
		- 10/21/2016 SG
	> 1.2 Added boolean to conversionTypes
		- 11/02/2016 SG
	> 1.3 Since this also handles data validation/conversion, allow to do so without being a required field
		- 11/22/2016 SG
	> 1.4 Added ability for a validator to have a validator in case the validator is actually a configured input with a sub key
		- 11/23/2016 SG
	> 1.5 Added ability for a validator's requirement to be Regex
		- 01/05/2017 SG
	> 1.6 Added split() to array data type in case it's a basic string
		- 06/16/2017 SG
	> 1.7 Added getConversionType() for use of conversionTypes outside of the full requirer structure
		- 03/25/2018 SG
 * @author      Silas Garrison (http://silasgarrison.com/)
 ** EXAMPLES:
 	validate form data:
		var data = {firstName : 'Silas',lastName : '', email : ''},
			validations = {},
			isValid = app.requirer.parse(
				data,
				{
					firstName : {
						required : true,
						label : 'First Name'
					},
					lastName : function(data, validations, messenger){
						if(data.lastName !== 'Garrison'){
							messenger('The last name HAS to be Garrison!');
							return false;
						}

						return true;
					},
					email : {
						required : true,
						dataType : 'email',
						label : 'Email'
					}
				}
			);
			// alerts ('First Name is required')
 ** NOTE:
 ** TODO:
*/

app.addFeature(
	"requirer",
	function(){
		"use strict";

		var self = this,
			messenger = window.alert,
			defaultMessage = "{if:label}{label}{else}{properties.label}{/if} is required.",
			supportTypes = {
				email : "isEmail"
			},
			conversionTypes = {
				"number" : function(val, vald){
					return val === undefined || val === ''?'':(val || "").val();
				},
				"boolean" : function(val, vald){
					var trueValues = ["1","yes","true","okay"];

					val = val.toString().toLowerCase().trim();

					return trueValues.indexOf(val) !== -1;
				},
				"array" : function(val, vald){
					try {
						val = JSON.parse(val);
					}
					catch(e){
						if(typeof val === "string"){
							val = val.split(",");
						}
					}

					return val;
				}
			};

		/*
			Name: init
			Use: API.init()
			Args: none
			Description:
		*/
		self.init = function(){

		};

		/*
			Name: parse
			Use: API.parse()
			Args: values Object - Hashmap of data to validate
					validator Object - Hashmap of requirements to meet in the data
			Description: Parses required data
		*/
		self.parse = function(values,validator){
			var key = "",
				vald,
				pass = true;

			for(key in validator){
				vald = validator[key];
				values[key] = values[key] === undefined?'':values[key];

				var isVisible = $('#' + key).is(':visible').length === 0 
					|| $('#' + key).is(':visible') 
					|| (vald?.type === 'signature' && $(`#canvas_${key}`).is(':visible'))  // check if a signature field's canvas input is visible.. because the value is in a hidden input
					|| (vald?.type === 'checkbox' && $(`#${key}0`).is(':visible'));  // checkbox inputs have an index added to their ids .. check that the first input is visible
					
				try {
					if(fld[0].disabled) {
						isVisible = false;
					}
				}
				catch(e){}

				/*
					NOTE:
						Test for data type conversions
				*/
				if(conversionTypes[vald.type]){
					values[key] = conversionTypes[vald.type](values[key], vald);
				}
				if(conversionTypes[vald.dataType]){
					values[key] = conversionTypes[vald.dataType](values[key], vald);
				}

				/*
					NOTE:
						Validators can be custom functions that just pass back true/false on whether it passed
				*/
				if(typeof vald === "function"){
					pass = vald(values, validator, messenger);

					if(pass === false){
						break;
					}
				}
				else if(typeof vald.validator === "function"){
					pass = vald.validator(values, vald, messenger);

					if(pass === false){
						break;
					}
				}
				else if(typeof vald.validator === "string" && typeof window[vald.validator] === "function"){
					pass = window[vald.validator](values,vald);

					if(pass === false){
						break;
					}
				}
				else {
					/*
						NOTE:
							If the validator has required explicitly set to false, don't run validation.  We probably just wanted conversion above
					*/
					if(vald.required !== false && vald.required !== undefined){
						/*
							NOTE:
								The default is just testing existence/empty string
						*/
						pass = !((values[key] === undefined?"":values[key]).toString().trim() === "");
						
						if (vald?.type === 'reload' && values[key + '_values'] !== "") {
							const reloadValues = JSON.parse(values[key + '_values']);
							pass = Array.isArray(reloadValues) && reloadValues.length;
						}

						/*
							NOTE:
								If it passes test for direct value - it has to equal the exact value
								Other validators are just of a specific type
						*/
						if(pass){
							if(vald.value !== undefined){
								pass = vald.value === values[key];
							}
							else if(supportTypes[vald.type]){
								pass = values[key].toString()[supportTypes[vald.type]]();
							}
							else if(supportTypes[vald.dataType]){
								pass = values[key].toString()[supportTypes[vald.dataType]]();
							}
						}

						if(pass && vald.regex){
							pass = new RegExp(vald.regex).test((values[key] || "").toString().trim());
						}

						// Do not require fields that are NOT visible
						if(!pass && !isVisible) pass = true;

						if(!pass && isVisible){
							messenger(
								(vald.message || defaultMessage).compile(vald)
							);

							break;
						}
					}
				}
			}

			return pass;
		};

		/*
			Name: setConversionType
			Use: API.setConversionType()
			Args: key String - The name/key of the conversion type
					fn Function - The function that will be the converter
			Description: Sets a new data conversion type
		*/
		self.setConversionType = function(key, fn){
			conversionTypes[key] = fn;
			return self;
		};

		/*
			Name: getConversionType
			Use: API.getConversionType()
			Args: key String - The name/key of the conversion type
			Description: Gets a conversion type method
		*/
		self.getConversionType = function(key){
			 return conversionTypes[key] || function(a){return a};
		};

		/*
			Name: setMessenger
			Use: API.setMessenger()
			Args: fn Function - The function that will be the new message/alert box
			Description: Sets the message/alert modal method to fire to the user
		*/
		self.setMessenger = function(fn){
			messenger = fn;

			return self;
		};

		/*
			Name: setMessenger
			Use: API.setMessenger()
			Args: message String - New default message
			Description: Sets the default message
		*/
		self.setDefaultMessage = function(message){
			defaultMessage = message;

			return self;
		};

		return self;
	}
);
